module.exports = __webpack_public_path__ + "static/auto_5-a67f345f88e49ed8ac25d6c79e2dc52b.jpg";